import {
  getTextValue,
  handleCategoryChange,
  handleMultiSelectChange,
  handleSingleSelectChange,
  handleTextChange,
  parseFiltersByField,
} from "@/components/ui/filters/filterHandlers";
import { MultiSelectFilter } from "@/components/ui/filters/MultiSelectFilter";
import { SingleSelectFilter } from "@/components/ui/filters/SingleSelectFilter";
import { TextFilter } from "@/components/ui/filters/TextFilter";
import {
  categoryOptions,
  genderOptions,
  storyTypeOptions,
  subcategoryOptions,
} from "@/utils/datagrid-utils";
import { DeleteOutline } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import { GridFilterItem } from "@mui/x-data-grid";
import { useMemo } from "react";

type SubmissionFiltersProps = {
  items: GridFilterItem[];
  onChange: (items: GridFilterItem[]) => void;
};

export function SubmissionFilters({ items, onChange }: SubmissionFiltersProps) {
  const filtersByField = useMemo(() => parseFiltersByField(items), [items]);

  return (
    <Stack direction="row" gap={1} flexWrap="wrap" alignItems="center">
      <TextFilter
        field="id"
        label="ID"
        value={getTextValue("id", filtersByField)}
        onChange={(field, val) => handleTextChange(field, val, items, onChange)}
      />
      <MultiSelectFilter
        field="story"
        label="Story Type"
        options={storyTypeOptions}
        value={filtersByField["story"] ?? []}
        onChange={(field, values) =>
          handleMultiSelectChange(field, values, items, onChange)
        }
      />
      <SingleSelectFilter
        field="category"
        label="Category"
        options={categoryOptions}
        value={getTextValue("category", filtersByField)}
        onChange={(field, val) =>
          handleCategoryChange(field, val, items, onChange)
        }
      />
      <SingleSelectFilter
        field="subcategory"
        label="Subcategory"
        disabled={!getTextValue("category", filtersByField)}
        options={subcategoryOptions(getTextValue("category", filtersByField))}
        value={getTextValue("subcategory", filtersByField)}
        onChange={(field, val) =>
          handleSingleSelectChange(field, val, items, onChange)
        }
      />
      <SingleSelectFilter
        field="gender"
        label="Gender"
        options={genderOptions}
        value={getTextValue("gender", filtersByField)}
        onChange={(field, val) =>
          handleSingleSelectChange(field, val, items, onChange)
        }
      />
      <IconButton disabled={items.length === 0} onClick={() => onChange([])}>
        <DeleteOutline />
      </IconButton>
    </Stack>
  );
}
